
export default function AboutSection() {
  const features = [
    {
      icon: 'ri-award-line',
      title: '15+ Years Experience',
      description: 'Established bollard installation specialists with extensive industry knowledge'
    },
    {
      icon: 'ri-team-line',
      title: 'Certified Technicians',
      description: 'Fully trained and certified installation professionals'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Guarantee',
      description: '5-year warranty on all installations and materials'
    },
    {
      icon: 'ri-time-line',
      title: '24/7 Emergency Service',
      description: 'Round‑the‑clock support for urgent security needs'
    }
  ];

  const certifications = [
    'CSCS Certified',
    'NRSWA Qualified',
    'ISO 9001:2015',
    'SafeContractor Approved',
    'Constructionline Gold',
    'CHAS Accredited'
  ];

  return (
    <section id="about" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              About <span className="text-yellow-500">Bollard Installation Essex</span>
            </h2>
            <p className="text-xl text-gray-300 mb-8">
              Leading bollard installation specialists serving Essex and surrounding areas. We provide comprehensive security solutions to protect your property from vehicle‑related crimes and unauthorized access.
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start">
                <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-check-line text-black text-sm"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-2">Professional Installation</h4>
                  <p className="text-gray-400">
                    Our certified technicians ensure every bollard is installed to the highest standards, meeting all safety and security requirements.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-check-line text-black text-sm"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-2">Custom Solutions</h4>
                  <p className="text-gray-400">
                    We design and implement bespoke security solutions tailored to your specific property requirements and risk assessment.
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center mr-4 mt-1">
                  <i className="ri-check-line text-black text-sm"></i>
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-2">Ongoing Support</h4>
                  <p className="text-gray-400">
                    Comprehensive maintenance and support services to ensure your security systems remain effective and operational.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-black/50 backdrop-blur-sm rounded-xl p-6 border border-yellow-500/20">
              <h4 className="text-lg font-semibold text-white mb-4">Certifications & Accreditations</h4>
              <div className="grid grid-cols-2 gap-3">
                {certifications.map((cert, index) => (
                  <div key={index} className="flex items-center">
                    <i className="ri-medal-line text-yellow-500 mr-2"></i>
                    <span className="text-gray-300 text-sm">{cert}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div>
            <div className="mb-8">
              <img
                src="https://public.readdy.ai/ai/img_res/0fd8d6f40a96d4cdc57b495cd2b9203e.jpg"
                alt="Bollard Installation Essex Team"
                className="w-full h-80 object-cover object-top rounded-xl"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-black/50 backdrop-blur-sm rounded-xl p-6 border border-yellow-500/20"
                >
                  <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center mb-4">
                    <i className={`${feature.icon} text-black text-xl`}></i>
                  </div>
                  <h4 className="text-lg font-semibold text-white mb-2">{feature.title}</h4>
                  <p className="text-gray-400 text-sm">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-yellow-500/10 rounded-xl p-8 border border-yellow-500/20">
            <h3 className="text-2xl font-bold text-white mb-4">Why Choose Bollard Installation Essex?</h3>
            <p className="text-gray-300 mb-6 max-w-3xl mx-auto">
              With over 15 years of experience and thousands of successful installations across Essex, we're the trusted
              choice for businesses and organizations requiring reliable security solutions. Our commitment to quality,
              safety, and customer satisfaction sets us apart.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-500 mb-2">2,500+</div>
                <div className="text-white">Installations Completed</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-500 mb-2">98%</div>
                <div className="text-white">Customer Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-500 mb-2">24hrs</div>
                <div className="text-white">Emergency Response</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

/* --------------------------------------------------------------------------
 * Additional component – previously duplicated as a second default export.
 * Keeping it as a named export to avoid "multiple default exports" error.
 * -------------------------------------------------------------------------- */
export function AboutStatsSection() {
  const stats = [
    { number: '500+', label: 'Bollards Installed' },
    { number: '15+', label: 'Years Experience' },
    { number: '100%', label: 'Customer Satisfaction' },
    { number: '24/7', label: 'Emergency Service' }
  ];

  return (
    <section id="about-stats" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Essex's Leading <span className="text-yellow-500">Bollard Specialists</span>
            </h2>
            <p className="text-xl text-gray-300 mb-6">
              We specialize in three types of bollard installation: telescopic bollards for maximum protection,
              fold down bollards for budget‑conscious customers, and electric bollards for luxury properties.
            </p>
            <p className="text-gray-400 mb-8">
              Our expert team provides professional installation services for both residential driveways and
              commercial properties throughout Essex. With years of experience and a commitment to quality, we
              ensure your property gets the protection it deserves.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-home-line text-black text-2xl"></i>
                </div>
                <h4 className="text-white font-semibold mb-2">Residential</h4>
                <p className="text-gray-400 text-sm">Protect your driveway and property</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-building-line text-black text-2xl"></i>
                </div>
                <h4 className="text-white font-semibold mb-2">Commercial</h4>
                <p className="text-gray-400 text-sm">Secure business premises</p>
              </div>
            </div>

            <button className="bg-yellow-500 text-black px-6 py-3 rounded-lg font-semibold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer">
              Learn More About Us
            </button>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20bollard%20installation%20team%20working%20on%20telescopic%20bollards%20in%20Essex%20residential%20driveway%2C%20expert%20technicians%20with%20tools%20and%20equipment%2C%20quality%20workmanship%20and%20professional%20service&width=600&height=400&seq=about-image&orientation=landscape"
              alt="Professional Bollard Installation"
              className="rounded-lg object-cover object-top w-full h-96"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-lg"></div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-yellow-500 mb-2">{stat.number}</div>
              <div className="text-gray-400">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}